import { Result, Button } from 'antd'
import { useNavigate } from 'react-router-dom'

const Developing = () => {
  const navigate = useNavigate()

  return (
    <Result
      status="500"
      subTitle="正在加紧开发中..."
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          返回首页
        </Button>
      }
    />
  )
}

export default Developing
